import actions from "./actions";

const initState = {
  myMenuUsers: [],
  allDiscounts: [],
  discountReferences: [],
  loading: false,
};

export default function discountReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_ALL_USERS_FROM_MYMENU_SUCCESS:
      return {
        ...state,
        myMenuUsers: action.myMenuUsers,
      };
    case actions.GET_ALL_DISCOUNTS_SUCCESS:
      return {
        ...state,
        allDiscounts: action.allDiscounts,
      };
    case actions.APPEND_DISCOUNTS_SUCCESS:
      const updatedMyMenuUsers = state.myMenuUsers.map((user) => {
        if (user.id === action.discount.userId) {
          return {
            ...user,
            discounts: [...user.discounts, action.discount],
          };
        }
        return user;
      });

      return {
        ...state,
        myMenuUsers: updatedMyMenuUsers,
      };
    case actions.REMOVE_DISCOUNTS_SUCCESS:
      const deleteMyMenuUsersDiscount = state.myMenuUsers.map((user) => {
        if (user.id === action.data.data.userId) {
          return {
            ...user,
            discounts: user.discounts.filter((discount) => {
              return (
                discount.touchSaleExportCode !==
                action.data.data.TouchSaleExportCode
              );
            }),
          };
        }
        return user;
      });

      return {
        ...state,
        myMenuUsers: deleteMyMenuUsersDiscount,
      };

    case actions.GET_DISCOUNTS_REFERENCES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_DISCOUNTS_REFERENCES_SUCCESS:
      return {
        ...state,
        discountReferences: action.discountReferences,
        loading: false,
      };

    default:
      return state;
  }
}
